export default __webpack_public_path__ + "static/media/delete-green.e7ba2cbd.svg";